import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AppRoutingModule, routingComponents } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { ErrorInterceptor } from './helper/Interceptor/error.interceptor';
import { HttpCallHandleService } from './helper/Interceptor/http-call-handle.service';
import { JWTInterceptor } from './helper/Interceptor/jwt.interceptor';
import { AuthService } from './helper/service/auth.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { RouterModule } from '@angular/router';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeng/themes';
import Material from '@primeng/themes/material';

// Matches the old PrimeNG 17 "mdc-light-indigo" theme
const MdcIndigo = definePreset(Material, {
  semantic: {
    primary: {
      50: '{indigo.50}', 100: '{indigo.100}', 200: '{indigo.200}', 300: '{indigo.300}', 400: '{indigo.400}',
      500: '{indigo.500}', 600: '{indigo.600}', 700: '{indigo.700}', 800: '{indigo.800}', 900: '{indigo.900}', 950: '{indigo.950}'
    },
    // Rounded fields and popups across all form controls
    formField: { borderRadius: '10px' },
    list: {
      padding: '0.375rem',
      gap: '2px',
      option: { borderRadius: '8px' }
    },
    content: { borderRadius: '10px' },
    overlay: {
      select: { borderRadius: '12px' },
      popover: { borderRadius: '12px' },
      modal: { borderRadius: '12px' }
    }
  }
});

@NgModule({
  declarations: [
    AppComponent, routingComponents,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CoreModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
    ToastModule,
    ConfirmPopupModule,
    DynamicDialogModule
  ],
  providers: [
    HttpCallHandleService,
    AuthService,
    MessageService,
    ConfirmationService,
    DialogService,
    providePrimeNG({ ripple: true, theme: { preset: MdcIndigo, options: { darkModeSelector: false, cssLayer: false } } }),
    { provide: HTTP_INTERCEPTORS, useClass: JWTInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
